import * as React from 'react';
import Select from '../select';
let MiniSelect = /** @class */ (() => {
    class MiniSelect extends React.Component {
        render() {
            return <Select size="small" {...this.props}/>;
        }
    }
    MiniSelect.Option = Select.Option;
    return MiniSelect;
})();
export default MiniSelect;
